import React from 'react';
import { env } from '@/env';
import { PasswordAccountForm } from './PasswordAccountForm';
import { OtpAccountStep } from './OtpAccountStep';

// Account-creation step. Behind the RND-35692 feature flag, account creation
// uses a phone/OTP flow (OtpAccountStep) instead of the password form. Default
// OFF (VITE_PASSWORDLESS_OTP_ENABLED unset/false) → password path, which stays
// the working default until Haim's OTP backend + contract land.
const CreateAccountStep: React.FC = () =>
  env.PASSWORDLESS_OTP_ENABLED === 'true' ? <OtpAccountStep /> : <PasswordAccountForm />;

export { CreateAccountStep };
